<template>
  <icon :size="size" :type="sensorType"/>
</template>

<script>
import Icon from './Icon';

export default {
  name: 'sensor-icon',
  props: {
    size: {
      type: Number,
      default: 48,
    },
    sensorType: String,
  },
  components: {
    Icon,
  },
};
</script>

<style scoped lang="sass">
</style>
